import {Icon} from 'react-exo/icon';
import {Link} from '@react-navigation/native';
import {View, Text} from 'react-native';
import {StyleSheet} from 'react-native-unistyles';
import {createElement} from 'react';
import {useLinkState} from './use-link-state';
import type {MenuItemProps} from './use-link-state';

export function MenuItemList(props: MenuItemProps) {
  const {ref, active, focused} = useLinkState(props);

  return (
    <Link screen={props.name} params={{}} style={{width: '100%'}}>
      <View ref={ref} style={[
        styles.root,
        active && styles.active,
        focused && styles.focused,
      ]}>
        {props.options?.icon && createElement(Icon, {
          name: props.options?.icon,
          size: __TOUCH__ ? 20 : 18,
          uniProps: (theme) => ({
            color: active
              ? theme.colors.foreground
              : theme.colors.mutedForeground,
          }),
        })}
        <Text style={styles.label}>
          {props.options?.title}
        </Text>
      </View>
    </Link>
  );
}

const styles = StyleSheet.create((theme) => ({
  root: {
    width: '100%',
    flexDirection: 'row',
    alignItems: 'center',
    borderRadius: theme.display.radius1,
    paddingHorizontal: theme.display.space2,
    borderColor: 'transparent',
    borderWidth: 1,
  },
  active: {
    backgroundColor: theme.colors.secondary,
  },
  focused: {
    borderColor: theme.colors.ring,
  },
  label: {
    userSelect: 'none',
    marginHorizontal: theme.display.space1,
    color: theme.colors.secondaryForeground,
    fontSize: theme.font.size,
    lineHeight: theme.font.headerHeight,
    letterSpacing: theme.font.spacing,
    ...__TOUCH__ && {
      marginLeft: theme.display.space2,
      lineHeight: 40,
      fontSize: 14,
    },
  },
}));

